export default __webpack_public_path__ + "static/media/round-table(cp).339bb674.png";